import {Inject, Component, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { Capacity } from '../../../models/capacity';
import { CapacityService } from '../../../services/capacity.service';
import { WebSocketService } from '../../../../../services/web-socket.service';


const VEHICLE_CAP_UPDATE = 'vehicCapUpdate';
  
  /**
   * Dialog Data
   */
export interface DialogData {

  /**
   * capacity
   */
  id: string;
}

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})



export class CapacityEditComponent implements OnInit {
  /**
   * Is creating
   */
  isCreating: boolean;

  /**
   * Cacpacity form
   */
  capacityForm: FormGroup;

  /**
   * Capacity
   */
  capacity: Capacity;

  constructor(public dialogRef: MatDialogRef<CapacityEditComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private capacityService: CapacityService,
              public wsService: WebSocketService,) { }

  ngOnInit(): void {
    this.capacityForm = new FormGroup({
      type: new FormControl(null, [Validators.required, Validators.maxLength(15)]),
      description: new FormControl(null, [Validators.required, Validators.maxLength(45)]),
      value: new FormControl(null, Validators.maxLength(255)),
      definition: new FormControl(null, [Validators.maxLength(255)]),//  , Validators.pattern('^\{\"[A-Z,a-z,0-9]*\":\s*\[\s*([0-9]*(,\s*[0-9]+)*)\]\}$')
      active: new FormControl(null),
      slots: new FormControl(null)
    });

    if (this.data) {  
      this.capacityService.findFiltered( { id: this.data.id }).subscribe(
        (capacity: any) => {
          if (capacity.length > 0) {
            this.capacity = capacity[0];
            this.isCreating = false;
            for (const i in this.capacityForm.controls) {
              if (this.capacityForm.controls.hasOwnProperty(i)) {
                this.capacityForm.controls[i].setValue(this.capacity[i]);
              }
            }
          }
        });
    } else {
      this.capacity = new Capacity();
      this.isCreating = true;
    }
  }


  /**
   * Save capacity form
   */
  save(): void {
    for (const i in this.capacityForm.controls) {
      if (this.capacityForm.controls.hasOwnProperty(i) && this.capacityForm.controls[i].value !== null) {
        this.capacity[i] = this.capacityForm.controls[i].value;
      }
    }
    if (this.isCreating) {
      this.capacityService.create(this.capacity).subscribe(() => this.dialogRef.close({}));
    } else {
      this.capacityService.update(this.capacity).subscribe(() => this.dialogRef.close({}));
    }
    this.emitCapacityUpdate();
  }

  /**
   * 
   */
   emitCapacityUpdate() {
    const packet: any = {};
    packet.msg_type = VEHICLE_CAP_UPDATE;
    packet.updated = true;

    this.wsService.send(VEHICLE_CAP_UPDATE, packet);
  }

  /**
   * Close dialog
   */
  close(): void {
    this.dialogRef.close();
  }
  activateCapacity(event){
    this.capacity.value = event.checked;
  }

  activateSlots(event){
    this.capacity.slots = event.checked;
  }

}
